/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';
import { ContentModuleModal, ColorField, TextField } from '@molecules';
import useEventColors from '@hooks/useEventColors';

import Form from '../Form';

import { FORM_FIELD, INITIAL_VALUES } from './constants';
import Item from './Item';

const LatestNewsPanelArticles = ({
  visible,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues = INITIAL_VALUES,
  errors,
}) => {
  const [form] = Form.useForm();
  const eventColors = useEventColors();

  const handleCancel = React.useCallback(() => {
    form.resetFields();
    hide();
  }, [form, hide]);

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      handleCancel();
    },
    [onSubmit, handleCancel],
  );

  return (
    <ContentModuleModal
      visible={visible}
      title="Latest news panel"
      subtitle="Choose background colour for latest news panel."
      okText={onDelete ? 'SAVE CHANGES' : 'ADD COLOUR'}
      onCancel={handleCancel}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onSerializedFinish={handleFinish}
      >
        <TextField {...FORM_FIELD.TITLE} />
        <ColorField {...FORM_FIELD.BACKGROUND_COLOR} style={NO_MARGIN_BOTTOM} mergeColors={eventColors} />
      </Form>
    </ContentModuleModal>
  );
};

LatestNewsPanelArticles.Item = Item;

export default LatestNewsPanelArticles;
